import { render, staticRenderFns } from "./BrInvalidStatusCount.vue?vue&type=template&id=a47c4a18&scoped=true"
import script from "./BrInvalidStatusCount.vue?vue&type=script&lang=js"
export * from "./BrInvalidStatusCount.vue?vue&type=script&lang=js"
import style0 from "./BrInvalidStatusCount.vue?vue&type=style&index=0&id=a47c4a18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47c4a18",
  null
  
)

export default component.exports